export class SVG {

  static font = "-apple-system, BlinkMacSystemFont, 'Inter', sans-serif";

  static rect(x: number, y: number, width: number, height: number, css_class?: string,): SVGRectElement {
    const rect = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    rect.setAttribute("x", x + "px");
    rect.setAttribute("y", y + "px");
    rect.setAttribute("width", width + "px");
    rect.setAttribute("height", height + "px");
    if (css_class !== undefined) {
      rect.classList.add(css_class);
    }
    return rect;
  }

  static svg_with_view_box(w: number, h: number): SVGSVGElement {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 " + w + " " + h);
    return svg
  }

  static svg(w: number, h: number, cssClass?: string): SVGSVGElement {
    const svg = SVG.svg_with_view_box(w, h);
    svg.setAttribute("width", w.toString());
    svg.setAttribute("height", h.toString());
    if (cssClass !== undefined) {
      svg.classList.add(cssClass);
    }
    return svg;
  }

  static path(d: string, cssClass?: string): SVGPathElement {
    const p = document.createElementNS("http://www.w3.org/2000/svg", "path");
    p.setAttribute("d", d);
    if (cssClass !== undefined) {
      p.classList.add(cssClass);
    }
    return p;
  }

  static dots(): SVGSVGElement {
    const svg = SVG.svg(20, 20, "dots");
    const c1 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    c1.setAttribute("cx", "5");
    c1.setAttribute("cy", "10");
    c1.setAttribute("r", "1.5");
    const c2 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    c2.setAttribute("cx", "10");
    c2.setAttribute("cy", "10");
    c2.setAttribute("r", "1.5");
    const c3 = document.createElementNS("http://www.w3.org/2000/svg", "circle");
    c3.setAttribute("cx", "15");
    c3.setAttribute("cy", "10");
    c3.setAttribute("r", "1.5");
    svg.appendChild(c1);
    svg.appendChild(c2);
    svg.appendChild(c3);
    return svg;
  }

  static bars(): SVGSVGElement {
    const svg = SVG.svg(20, 20, "bars");
    const l1 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    l1.setAttribute("x1", "3");
    l1.setAttribute("y1", "8");
    l1.setAttribute("x2", "17");
    l1.setAttribute("y2", "8");
    l1.setAttribute("stroke-width", "2");
    l1.setAttribute("stroke-linecap", "round");
    const l2 = document.createElementNS("http://www.w3.org/2000/svg", "line");
    l2.setAttribute("x1", "3");
    l2.setAttribute("y1", "12");
    l2.setAttribute("x2", "17");
    l2.setAttribute("y2", "12");
    l2.setAttribute("stroke-width", "2");
    l2.setAttribute("stroke-linecap", "round");
    svg.appendChild(l1);
    svg.appendChild(l2);
    return svg;
  }

  static x(w: number = 30, h: number = 30, size: number = 10): SVGSVGElement {
    const svg = SVG.svg(w, h, "x");
    const x_offset = (w - size) / 2;
    const y_offset = (h - size) / 2;
    const p1 = "M" + x_offset + " " + y_offset + "L" + (x_offset + size) + " " + (y_offset + size);
    const p2 = "M" + (x_offset + size) + " " + y_offset + "L" + x_offset + " " + (y_offset + size);
    svg.appendChild(SVG.path(p1));
    svg.appendChild(SVG.path(p2));
    return svg;
  }

  static plus_icon(box: number = 26, size: number = 14): SVGSVGElement {
    const inset = (box - size) / 2;
    const svg = SVG.svg(box, box, "add-icon");
    const p1 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    const d1 = "M" + inset + " " + (box / 2) + "L" + (box - inset) + " " + (box / 2);
    p1.setAttribute("d", d1);
    svg.appendChild(p1);
    const p2 = document.createElementNS("http://www.w3.org/2000/svg", "path");
    const d2 = "M" + (box / 2) + " " + inset + "L" + (box / 2) + " " + (box - inset);
    p2.setAttribute("d", d2);
    svg.appendChild(p2);
    return svg;
  }

  static minus_icon(box: number = 26, size: number = 14): SVGSVGElement {
    const inset = (box - size) / 2;
    const svg = SVG.svg(box, box, "minus-icon");
    const d = "M" + inset + " " + (box / 2) + "L" + (box - inset) + " " + (box / 2);
    const p = SVG.path(d);
    svg.appendChild(p);
    return svg;
  }

  static chevron(color: string = "#bfbfbf"): SVGSVGElement {
    const svg = SVG.svg(10, 10, "chevron");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", color);
    svg.appendChild(SVG.path("M1 3L5 7L9 3"));
    return svg;
  }

  static pencil(): SVGSVGElement {
    const svg = SVG.svg(16, 16, "pencil");
    const p1 = SVG.path("M2 12L1 15L4 14L15 3L13 1L2 12Z");
    p1.setAttribute("stroke-linejoin", "round");
    svg.appendChild(p1);
    const p2 = SVG.path("M13 5L11 3");
    svg.appendChild(p2);
    return svg;
  }

  static logo(cssClass?: string): SVGSVGElement {
    const svg = SVG.svg(72, 62.4, "logo");
    if (cssClass !== undefined) {
      svg.classList.add(cssClass);
    }
    const p = SVG.path("M34.9046 30.5084H38.3816L36.6536 26.1546L34.9046 30.5084ZM18.5884 24.9927H16.8385V32.7821H18.5884C21.1573 32.7821 22.8626 31.3807 22.8626 28.909V28.8658C22.8617 26.4148 21.1555 24.9927 18.5884 24.9927ZM62.7736 0H9.2264C6.78168 0.00684239 4.43907 0.969404 2.71031 2.6774C0.981548 4.38541 0.00715675 6.70002 0 9.1156V53.2835C0.00715565 55.6992 0.981517 58.0139 2.71025 59.7221C4.43899 61.4302 6.7816 62.3929 9.2264 62.4H62.7736C65.2184 62.3929 67.561 61.4302 69.2898 59.7221C71.0185 58.0139 71.9928 55.6992 72 53.2835V9.1156C71.9928 6.70002 71.0185 4.38541 69.2897 2.6774C67.5609 0.969404 65.2183 0.00684239 62.7736 0ZM59.9904 21.2294L54.0993 30.747V36.5454H49.7814V30.8127L43.8921 21.2294H48.7848L51.9732 26.8082L55.1843 21.2294H59.9904ZM21.2448 6.61884H50.7552C52.6591 6.61884 54.2148 7.85684 54.2148 9.3715C54.2148 10.8862 52.6591 12.1233 50.7552 12.1233H21.2448C19.3409 12.1233 17.7852 10.8844 17.7852 9.3715C17.7852 7.85857 19.3409 6.61884 21.2448 6.61884ZM23.4689 43.9086H18.8185V55.5045H14.5225V43.9086H9.87299V40.1911H23.4698L23.4689 43.9086ZM18.4318 36.5437H12.5425V21.2294H18.521C24.0569 21.2294 27.2706 24.3797 27.2706 28.8001V28.8442C27.268 33.2628 24.0131 36.5445 18.4327 36.5445L18.4318 36.5437ZM40.4736 48.6782C40.4736 53.6224 37.6178 55.7898 33.2115 55.7898C28.8053 55.7898 26.0369 53.5792 26.0369 48.7871V40.1911H30.4003V48.7015C30.4003 50.9113 31.5299 51.9617 33.257 51.9617C34.9842 51.9617 36.1137 50.9554 36.1137 48.8113V40.1911H40.4763V48.6799L40.4736 48.6782ZM39.6214 33.8083H33.6429L32.5352 36.5445H28.0178L34.6167 21.1196H38.7579L45.3568 36.5445H40.751L39.6214 33.8083ZM60.3789 55.508H56.1056V46.7105L52.142 52.7052H52.0545L48.1172 46.7537V55.5054H43.9043V40.1911H48.4436L52.142 46.1201L55.8405 40.1911H60.3797V55.5062L60.3789 55.508Z");
    p.setAttribute("fill-rule", "evenodd");
    p.setAttribute("clip-rule", "evenodd");
    p.setAttribute("fill", "#C7C8CA");
    svg.appendChild(p);
    return svg;
  }

  static to_url(svg: SVGSVGElement): string {
    const s = new XMLSerializer().serializeToString(svg);
    return "data:image/svg+xml;base64," + window.btoa(s);
  }

  static render_to_image(svg: SVGSVGElement, viz_id: string, cb: Function) {

    const rect = svg.getBoundingClientRect();
    const canvas = document.createElement("canvas");
    const width = 480;
    const height = width / (rect.width / rect.height);
    canvas.setAttribute("width", width.toString());
    canvas.setAttribute("height", height.toString());
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      return;
    }

    const image = new Image;
    const s = new XMLSerializer().serializeToString(svg);
    const url = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(s);
    image.src = url;

    image.onload = function () {
      ctx.drawImage(image, 0, 0);

      // to download:
      /*
      const data = canvas.toDataURL("image/png");
      var a = document.createElement("a");
      a.download = "filename.png";
      a.href = data;
      a.click();
      */

      canvas.toBlob(function (blob) {
        cb(viz_id, blob);
      }, "image/png");

      if (canvas.parentElement) {
        canvas.parentElement.removeChild(canvas);
      }
    };
  }

}